<template>
  <div class="animated fadeIn">
    <div class="splash" v-if="!preloadDone">
      <div class="container d-flex h-100">
        <div class="row justify-content-center text-primary w-100 align-self-center text-white">
          <i class="fa fa-spin fa-spinner"></i>
        </div>
      </div>
    </div>

    <div class="container mt-3" v-if="preloadDone && result">
      <div role="tablist" class="oportunity">
        <b-card>
          <b-card-header header-tag="header" header-bg-variant="info" class="p-3">
            <b-row>
              <b-col class="text-center summary-wrapper" md="3" v-if="result.count_first_criteria !== undefined">
                <div class="summary-header">Operadores <br>>= 325€</div>
                <div class="summary-value">
                  <div class="value">{{ result.count_first_criteria | currency({fractionCount:0, symbol:''}) }}</div>
                  <div class="percentage">
                    {{ (result.count_first_criteria * 100 / 40) | currency({fractionCount:1, symbol:'%'}) }}
                    (Obj: 40)
                  </div>
                </div>
              </b-col>

              <b-col class="text-center summary-wrapper" md="3" v-if="result.count_second_criteria !== undefined">
                <div class="summary-header">Operadores <br>>= 390€</div>
                <div class="summary-value">
                  <div class="value">{{ result.count_second_criteria | currency({fractionCount:0, symbol:''}) }}</div>
                  <div class="percentage">
                    {{ (result.count_second_criteria * 100 / 30) | currency({fractionCount:1, symbol:'%'}) }}
                    (Obj: 30)
                  </div>
                </div>
              </b-col>

              <b-col class="text-center summary-wrapper" md="3" v-if="result.count_third_criteria !== undefined">
                <div class="summary-header">Operadores <br>>= 500€</div>
                <div class="summary-value">
                  <div class="value">{{ result.count_third_criteria | currency({fractionCount:0, symbol:''}) }}</div>
                  <div class="percentage">
                    {{ (result.count_third_criteria * 100 / 20) | currency({fractionCount:1, symbol:'%'}) }}
                    (Obj: 20)
                  </div>
                </div>
              </b-col>

              <b-col class="text-center summary-wrapper" md="3" v-if="result.top15_sum_value !== undefined">
                <div class="summary-header">Soma Top 15 <br>Operadores</div>
                <div class="summary-value">
                  <div class="value">{{ result.top15_sum_value | currency({fractionCount:2, symbol:'€'}) }}</div>
                  <div class="percentage">
                    {{ (result.top15_sum_value * 100 / 22750) | currency({fractionCount:1, symbol:'%'}) }}
                    (Obj: 22.750 €)
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-card-header>

          <b-table
            v-if="result.results"
            responsive
            stacked="sm"
            :striped="true"
            :fields="resultFields"
            :items="result.results"
            :sort-by="'value_ufs'"
            :sort-desc="true"
          >
            <template v-slot:cell(name)="data">
              {{ data.item.name }}
            </template>
            <template v-slot:cell(codle)="data">
              {{ data.item.codle }}
            </template>
            <template v-slot:cell(value_ufs)="data">
              {{ data.item.value_ufs | currency({fractionCount:2, symbol:'€'}) }}
            </template>
          </b-table>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Profile',
  data() {
    return {
      preloadDone: false,
      result: null,
      resultFields: [
        { key: 'name', label: 'Nome', sortable: true },
        { key: 'codle', label: 'Codle', sortable: true },
        { key: 'value_ufs', label: 'Valor UFS', sortable: true, width: '120px' },
        { key: 'ok', label: 'Cumpre', sortable: true, width: '120px' }
      ]
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      // console.log('Fetching data from: stars/oportunities/self/6')

      this.axios.get('stars/oportunities/self/7')
        .then(response => {
        // console.log('✅ API response received:', response)

          this.result = (response.data && response.data.data) ? response.data.data : {}
          // console.log('📦 Parsed result:', this.result)

          this.preloadDone = true
          // console.log('✅ Preload done set to true')
        })
        .catch(error => {
        // console.error('❌ Error loading data:', error)

          if (error.response) {
          //  console.error('Response data:', error.response.data)
          //  console.error('Response status:', error.response.status)
          //  console.error('Response headers:', error.response.headers)
          } else if (error.request) {
          //  console.error('No response received:', error.request)
          }

          this.preloadDone = true
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// oportunity-self.vue?afecfa84